<template>
    <el-form :model="form" ref="form" label-position="left" size="small" v-if="show" label-width="145px">
        <div class="detail-row footer payment-detail-check">
            <div id="payment-detail-check-auto-scroll-anchor"></div>
            <div class="detail-block">
                <h3>付款明細</h3>
                <el-form-item prop="paY_WAY" label="實際付款方式">
                    <el-radio-group v-model="form.paY_WAY" @change="handlePayWayChange" class="pay-way-radio-group">
                        <el-radio-button :disabled="payment.cny != 'TWD'" :label="1"> 零用現金 </el-radio-button>
                        <el-radio-button :label="3">銀行提現</el-radio-button>
                        <el-tooltip placement="top" content="申請人已選擇零用現金，若需改為銀行轉帳，請退件，由申請人填寫收款銀行資訊。" :manual="!isDisableBankTransfer">
                            <el-radio-button :label="2" :disabled="isDisableBankTransfer"> 銀行轉帳 </el-radio-button>
                        </el-tooltip>
                    </el-radio-group>
                    <el-alert :closable="false" type="warning" style="line-height: 160%; margin-top: 10px">
                        <template v-if="form.paY_WAY == 1">
                            <span>即時零用現金餘額：</span>
                            <Money :v="currCash" />
                        </template>
                        <template v-else>
                            <span>如有產生匯費，請至「銀行匯款明細、匯費」填寫匯費金額</span>
                        </template>
                    </el-alert>
                </el-form-item>
                <el-row :gutter="40">
                    <el-col :sm="12">
                        <el-form-item label="收款戶名" v-if="form.paY_WAY === 2">
                            <el-input v-if="payment" :value="payment.vdR_BNK_TPC" readonly :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="40">
                    <el-col :sm="12">
                        <el-form-item prop="paY_BNK_SNO" label="轉出帳戶" v-if="form.paY_WAY === 2 || form.paY_WAY === 3" :rules="rules.paY_BNK_SNO">
                            <ah-el-select-bank-account
                                v-model="form.paY_BNK_SNO"
                                document-type="payment"
                                :cny="payment.cny"
                                hide-borrower
                                :show-balance="this.isAuthOne(['A02', 'A03'])"
                            ></ah-el-select-bank-account>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="12">
                        <el-form-item prop="paY_DAT" label="實際付款日期" :rules="rules.paY_DAT">
                            <el-date-picker v-model="form.paY_DAT" value-format="timestamp" type="date" placeholder="請選擇"> </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item prop="iteM_SNO" label="支出項目" :rules="rules.iteM_SNO">
                    <template slot="label">支出項目</template>
                    <ahSelectVariableStateItem v-model="form.iteM_SNO" :enableType="['payout', 'cOut', 'cOutElse']" @change="onVariableStateItemChange"></ahSelectVariableStateItem>
                </el-form-item>
                <el-form-item v-if="isAhSuggestAccountingItemsSelectorShow" prop="accno" label="立帳科目">
                    <ahSuggestAccountingItemsSelector ref="ahSuggestAccountingItemsSelector" v-model="form.accno" @loaded="onAhSuggestAccountingItemsSelectorLoaded" size="small"></ahSuggestAccountingItemsSelector>
                </el-form-item>
                <el-form-item v-if="isAhSuggestAccountingItemsSelectorShow" prop="clearanceAccno" label="沖帳科目">
                    <ah-select-accounting-setting v-model="form.clearanceAccno" width="200px" :allowedGroups="['liabilitiesSettings', 'noeSettings']" size="small" />
                </el-form-item>
                <el-form-item prop="amt" v-if="payment.cny != 'TWD'">
                    <template slot="label">
                        當下匯率
                        <ah-tip>換算台幣支出總額，供營業支出相關分析使用。</ah-tip>
                    </template>
                    <el-input-number v-model="form.paY_CNYRAT" :precision="4" style="width: 150px" @change="onCnyRatChange"></el-input-number>
                    <div style="display: inline-block; margin-left: 10px">
                        <el-button size="mini" @click="applySysCnyRat(payment.cny)">即時匯率</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="約當台幣" v-if="payment.cny != 'TWD'">
                    <money-input size="small" v-model="payTwdAmt" style="width: 250px" @blur="onTwdAmtChange" suffix="TWD" />
                </el-form-item>
                <div class="tax-area" v-if="payment.paY_TO === 3" style="margin-top: 20px; padding-top: 20px; border-top: 1px solid #ddd">
                    <h3>勞務代扣稅款</h3>
                    <div class="service-type-note">
                        <div class="title">
                            <div style="display: flex; gap: 5px; align-items: center">
                                <div style="padding-right: 10px">所得類別：</div>
                                <el-select v-model="form.serviceType" placeholder="請選擇" style="width: 310px" @change="onChangeServiceType" :disabled="payment.tranServiceFeeStatement">
                                    <el-option v-for="serviceType in serviceTypeList" :key="serviceType.value" :label="serviceType.label" :value="serviceType.value"> </el-option>
                                </el-select>
                                <el-button @click="taxAndGen2Dialog.visible = true" icon="el-icon-notebook-2">各類代扣簡表</el-button>
                            </div>
                        </div>
                        <div class="title" v-if="form.serviceType === 1 || form.serviceType === 2">
                            <div style="display: flex; gap: 5px; align-items: center">
                                <div style="padding-right: 10px">業別代號：</div>
                                <el-input v-if="form.serviceType === 0" v-model="form.otherServiceType" :maxlength="50" :show-word-limit="true" style="width: 310px" />
                                <el-select
                                    v-else
                                    v-model="form.serviceSubType"
                                    filterable
                                    placeholder="請選擇"
                                    style="min-width: 310px; margin-right: 8px"
                                    no-data-text="無資料"
                                    no-match-text="無匹配資料"
                                    :disabled="payment.tranServiceFeeStatement"
                                >
                                    <el-option v-for="item in serviceSubTypeList" :key="item.key" :label="`${item.key}：${item.label}`" :value="item.key" />
                                </el-select>
                            </div>
                        </div>
                        <div v-if="payment.paY_TO === 3" style="margin-top: 30px">
                            <ol>
                                <li v-if="payment.abd === 2">勞務稅（非居住者）：{{ selectedServiceTypeInfo.notes.nonresidentTax }}</li>
                                <li v-else>勞務稅（居住者）：{{ selectedServiceTypeInfo.notes.residentTax }}</li>
                                <li>二代健保：{{ selectedServiceTypeInfo.notes.gen2 }}</li>
                                <li>如有產生匯費，請至「銀行匯款明細、匯費」填寫匯費金額。</li>
                            </ol>
                        </div>
                    </div>
                    <el-row :gutter="20">
                        <el-col :sm="12">
                            <div :class="[{ 'tax-area-block': true }]">
                                <el-form-item label="代扣所得稅">
                                    <el-checkbox v-model="form.taX_CHK" border style="margin-right: 0; background-color: #f6f6f6" @change="updateTaxAmt">勞務稅</el-checkbox>
                                </el-form-item>
                                <div
                                    :class="[
                                        {
                                            section: true,
                                            actived: taxCheck,
                                        },
                                    ]"
                                >
                                    <el-form-item prop="taX_AMT" label=" 勞務稅金" :rules="!taxCheck ? [{ required: false }] : rules.taX_AMT">
                                        <el-input v-model="tax_ratio" style="width: 70px; margin-right: 5px" @keyup.native="handleTaxRatioChange" :disabled="!taxCheck">
                                            <el-tooltip slot="suffix" content="勞務稅率" placement="top-start">
                                                <i style="margin-right: 6px; font-weight: bold">%</i>
                                            </el-tooltip>
                                        </el-input>
                                        <money-input v-model.number="form.taX_AMT" style="width: 130px" :disabled="true" suffix="元" size="small" />
                                    </el-form-item>
                                    <el-form-item v-if="tax_ratio > 0" prop="taX_PAY_DAT" label="繳款日期" :rules="!taxCheck ? [{ required: false }] : rules.taX_PAY_DAT">
                                        <el-date-picker v-model="form.taX_PAY_DAT" value-format="timestamp" type="date" placeholder="請選擇" :disabled="!taxCheck"> </el-date-picker>
                                        <div v-if="isTaxPayDateInvalid" class="date-warning">應於實際付款日之後</div>
                                    </el-form-item>
                                    <el-form-item v-if="tax_ratio > 0" prop="taX_BNK_SNO" label="繳款帳戶" :rules="!taxCheck ? [{ required: false }] : rules.taX_BNK_SNO">
                                        <ah-el-select-bank-account
                                            v-model="form.taX_BNK_SNO"
                                            document-type="payment"
                                            :disabled="!taxCheck"
                                            cny="TWD"
                                            hide-borrower
                                            :allow-cash="true"
                                        ></ah-el-select-bank-account>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                        <el-col :sm="12">
                            <div :class="[{ 'tax-area-block': true }]">
                                <el-form-item label="代扣二代健保">
                                    <el-checkbox v-model="form.geN2_CHK" border style="background-color: #f6f6f6" @change="updateGen2Amt">二代健保</el-checkbox>
                                </el-form-item>
                                <div
                                    :class="[
                                        {
                                            section: true,
                                            actived: gen2Check,
                                        },
                                    ]"
                                >
                                    <el-form-item prop="geN2_AMT" label="二代健保補充保費" :rules="!gen2Check ? [{ required: false }] : rules.geN2_AMT">
                                        <el-input v-model="gen2_ratio" style="width: 70px; margin-right: 5px" @keyup.native="handleGen2RatioChange" :disabled="!gen2Check">
                                            <el-tooltip slot="suffix" content="補充保險費(二代健保)費率" placement="top-start">
                                                <i style="margin-right: 6px; font-weight: bold">%</i>
                                            </el-tooltip>
                                        </el-input>
                                        <money-input v-model.number="form.geN2_AMT" style="width: 130px" :disabled="true" suffix="元" size="small" />
                                    </el-form-item>
                                    <el-form-item v-if="gen2_ratio > 0" prop="geN2_PAY_DAT" label="繳款日期" :rules="!gen2Check ? [{ required: false }] : rules.geN2_PAY_DAT">
                                        <el-date-picker v-model="form.geN2_PAY_DAT" value-format="timestamp" type="date" placeholder="請選擇" :disabled="!gen2Check"> </el-date-picker>
                                        <div v-if="isGen2PayDateInvalid" class="date-warning">應於實際付款日之後</div>
                                    </el-form-item>
                                    <el-form-item v-if="gen2_ratio > 0" prop="geN2_BNK_SNO" label="繳款帳戶" :rules="!gen2Check ? [{ required: false }] : rules.geN2_BNK_SNO">
                                        <ah-el-select-bank-account
                                            v-model="form.geN2_BNK_SNO"
                                            document-type="payment"
                                            :disabled="!gen2Check"
                                            cny="TWD"
                                            hide-borrower
                                            :allow-cash="true"
                                        ></ah-el-select-bank-account>
                                    </el-form-item>
                                </div>
                                <el-alert v-if="isGen2Covered" type="warning" style="" :closable="false">
                                    {{ form.vdR_NAM }}
                                    有投保職業工會或執照統編，免扣二代健保費。
                                </el-alert>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="realpay-total">
                        <div style="font-size: 13pt; font-weight: bold">實付金額：</div>
                        <money-input
                            :value="realPaidAmt"
                            :suffix="payment.cny"
                            :disabled="true"
                            :precision="payment.cny == 'TWD' ? 0 : 4"
                            style="max-width: 250px; font-size: 13pt; font-weight: bold"
                        />
                    </div>
                    <div v-if="payment.cny !== 'TWD'" class="twd">約當台幣：<Money :v="realPaidAmt * form.paY_CNYRAT" round /> 元</div>
                </div>
            </div>
            <div style="text-align: right; padding: 15px 0 10px 0; margin-top: 25px" id="payment-detail-check-actions">
                <el-button type="" @click="handleCancel">取消</el-button>
                <el-popover placement="top" title="暫存" width="250" :close-delay="0" :open-delay="1000" trigger="hover" content="預先填寫，待日後實際付款完再送出。">
                    <el-button slot="reference" type="primary" plain @click="handleSave" style="margin: 0 5px 0 15px">暫存付款明細</el-button>
                </el-popover>
                <el-button type="success" @click="handleSubmit" class="primary-action" :loading="isSubmitting">送出付款明細</el-button>
            </div>
        </div>
        <ahRichAlertDialog
            title="確定送出預約付款嗎？"
            description="您填寫了未來的實際付款日期"
            :visible="futureAlertDialog.visible"
            cancelText="否，取消"
            submitText="是，確定預約付款"
            @cancel="onAhRichAlertDialogCancel"
            @close="onAhRichAlertDialogClose"
            @submit="handleFutureAlertDialogSubmit"
        />
        <TaxAndGen2Dialog :visible="taxAndGen2Dialog.visible" @close="taxAndGen2Dialog.visible = false" />
    </el-form>
</template>
<script>
import { serviceTypeList, serviceType9AList, serviceType9BList } from '@/assets/commonData/options';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';
import ahRichAlertDialog from '@/components/ui/ahRichAlertDialog.vue';
import ahSuggestAccountingItemsSelector from '@/components/ui/ahSuggestAccountingItemsSelector.vue';
import TaxAndGen2Dialog from '@/components/ui/TaxAndGen2Dialog.vue';
import ahSelectAccountingSetting from '@/components/ui/ahSelectAccountingSetting.vue';

export default {
    name: 'payment-paid',
    props: ['show', 'payment', 'curr-audit', 'payToList'],
    components: {
        ahElSelectBankAccount,
        ahSelectVariableStateItem,
        ahRichAlertDialog,
        ahSuggestAccountingItemsSelector,
        TaxAndGen2Dialog,
        ahSelectAccountingSetting,
    },
    data() {
        const validatorItemSno = (rule, value, callback) => {
            if (value > 0) {
                callback();
            } else {
                callback(new Error('請選擇支出項目'));
            }
        };

        return {
            isAhSuggestAccountingItemsSelectorShow: true,

            isSubmitting: false,
            item: null,
            taX_CHK: null,
            geN2_CHK: null,
            payoutList: [],
            subpayoutList: [],
            bankList: [],
            paymentCopy: null,
            tax_ratio: 10,
            gen2_ratio: 2.11,
            cnyName: '',
            currCash: null,
            serviceTypeList,
            payTwdAmt: null,
            suggestAccountItems: [],

            form: {
                sno: null,
                paY_WAY: null,
                paY_BNK_SNO: null,
                paY_DAT: new Date().getTime(),
                iteM_SNO: null,
                accno: null,
                clearanceAccno: null,
                iteM_parent_SNO: null, // api 不儲存, 只有前端使用
                taX_CHK: false,
                taX_AMT: 0,
                taX_PAY_DAT: null,
                taX_BNK_SNO: null,
                geN2_CHK: false,
                geN2_AMT: 0,
                geN2_PAY_DAT: null,
                geN2_BNK_SNO: null,
                paY_CNYRAT: 1, // 外幣需要紀錄當下匯率
                audit: {},
                vdR_NAM: null,
                serviceType: null,
                serviceSubType: null,
                otherServiceType: null,
            },
            rules: {
                paY_DAT: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇付款日期',
                    },
                ],
                iteM_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇支出項目',
                    },
                    {
                        validator: validatorItemSno,
                    },
                ],
                paY_BNK_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇轉出帳戶',
                    },
                ],
                taX_AMT: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '請輸入勞務稅金',
                    },
                ],
                geN2_AMT: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '請輸入二代健保補充保費',
                    },
                ],
                taX_PAY_DAT: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇代扣稅繳款日期',
                    },
                ],
                geN2_PAY_DAT: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇代扣二代健保繳款日期',
                    },
                ],
                taX_BNK_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇代扣稅繳款帳戶',
                    },
                ],
                geN2_BNK_SNO: [
                    {
                        required: true,
                        trigger: 'change',
                        message: '請選擇代扣二代健保繳款帳戶',
                    },
                ],
            },
            expireTimeOption: {
                disabledDate(date) {
                    return date.getTime() >= Date.now();
                },
            },
            futureAlertDialog: {
                visible: false,
            },
            taxAndGen2Dialog: {
                visible: false,
            },
        };
    },
    mounted() {
        this.fetchCash();
    },
    computed: {
        serviceSubTypeList() {
            switch (this.form.serviceType) {
            case 1:
                return serviceType9AList;
            case 2:
                return serviceType9BList;
            default:
                return [];
            }
        },
        isDisableBankTransfer() {
            return this.payment && this.payment.useR_PAY_WAY === 1;
        },
        isOneOfTaxCheck() {
            return this.form.taX_CHK || this.form.geN2_CHK;
        },
        taxCheck() {
            return this.form.taX_CHK;
        },
        gen2Check() {
            return this.form.geN2_CHK;
        },

        isTaxPayDateInvalid() {
            return this.form.taX_CHK && this.form.taX_PAY_DAT != null && this.form.taX_PAY_DAT < this.form.paY_DAT;
        },
        isGen2PayDateInvalid() {
            return this.form.taX_CHK && this.form.geN2_PAY_DAT != null && this.form.geN2_PAY_DAT < this.form.paY_DAT;
        },
        isGen2Covered() {
            return this.payToList?.find((o) => o.sno === this.payment.vdR_SNO).oS_GRP;
        },
        realPaidAmt() {
            const TAX_AMT = Math.round((this.form.taX_AMT / this.form.paY_CNYRAT) * 100) / 100;
            const GEN2_AMT = Math.round((this.form.geN2_AMT / this.form.paY_CNYRAT) * 100) / 100;

            return this.payment.amt - GEN2_AMT - TAX_AMT;
        },
        selectedServiceTypeInfo() {
            if (this.payment) {
                return serviceTypeList.find((x) => x.value === this.form.serviceType);
            }
            return null;
        },
    },
    watch: {
        payment(newVal) {
            if (newVal) {
                console.log('newVal', newVal);

                this.form.accno = newVal.accno;
                this.form.clearanceAccno = newVal.typ === 2 ? '2121' : '2131';
                this.form.paY_WAY = newVal.paY_WAY ? newVal.paY_WAY : newVal.useR_PAY_WAY;
                this.form.sno = newVal.sno;
                this.form.paY_DAT = newVal.paY_DAT ? newVal.paY_DAT : newVal.pdat;
                this.form.paY_BNK_SNO = newVal.paY_BNK_SNO;
                this.form.iteM_SNO = newVal.iteM_SNO;

                this.form.taX_CHK = newVal.taX_CHK;
                this.form.taX_AMT = newVal.taX_AMT * newVal.paY_CNYRAT;
                this.form.taX_PAY_DAT = newVal.taX_PAY_DAT;
                this.form.taX_BNK_SNO = newVal.taX_PAY_WAY === 1 ? -1 : newVal.taX_BNK_SNO;

                this.form.geN2_CHK = newVal.geN2_CHK;
                this.form.geN2_AMT = newVal.geN2_AMT * newVal.paY_CNYRAT;
                this.form.geN2_PAY_DAT = newVal.geN2_PAY_DAT;
                this.form.geN2_BNK_SNO = newVal.geN2_PAY_WAY === 1 ? -1 : newVal.geN2_BNK_SNO;

                this.form.vdR_NAM = newVal.vdR_NAM;

                this.form.serviceType = newVal.serviceType;
                this.form.serviceSubType = newVal.serviceSubType;
                this.form.otherServiceType = newVal.otherServiceType;

                this.futureAlertDialog.visible = false;

                // 匯率
                if (newVal.cny !== 'TWD') {
                    if (newVal.paY_CNYRAT) {
                        this.form.paY_CNYRAT = newVal.paY_CNYRAT;
                    } else {
                        const cny = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === newVal.cny);
                        if (cny) {
                            this.form.paY_CNYRAT = cny.rat;
                        } else {
                            this.form.paY_CNYRAT = 1;
                        }
                    }
                    this.payTwdAmt = Math.round(this.payment.amt * this.form.paY_CNYRAT);
                } else this.form.paY_CNYRAT = 1;

                // if (this.form.typ !== 5 && this.form.paY_TO == 3)
                if (newVal.paY_TO === 3) {
                    // 回推當時稅率
                    if (this.form.taX_CHK) this.tax_ratio = Math.round((this.form.taX_AMT / (newVal.amt * newVal.paY_CNYRAT)) * 10000) / 100;
                    if (this.form.geN2_CHK) this.gen2_ratio = Math.round((this.form.geN2_AMT / (newVal.amt * newVal.paY_CNYRAT)) * 10000) / 100;
                }

                this.paymentCopy = newVal;
            }
        },
        currAudit(newVal) {
            if (newVal) {
                this.form.audit = {
                    sno: newVal.sno,
                    sot: newVal.sot,
                    fin: 1,
                    rsn: null,
                    menU_UNT: newVal.menU_UNT,
                };
            }
        },
    },
    methods: {
        onTwdAmtChange() {
            this.form.paY_CNYRAT = Math.round((this.payTwdAmt / this.payment.amt) * 100) / 100;
        },
        onCnyRatChange() {
            this.payTwdAmt = Math.round(this.payment.amt * this.form.paY_CNYRAT);
            this.updateTaxAmt();
            this.updateGen2Amt();
        },
        initAuSuggestAccountingItemsSelector() {
            if (this.form.iteM_SNO) {
                console.log(this.form.iteM_SNO);
                this.isAhSuggestAccountingItemsSelectorShow = true;
                this.$nextTick(() => {
                    this.$refs.ahSuggestAccountingItemsSelector.init(this.form.iteM_SNO);
                });
                console.log(this.form.accno);
            } else this.isAhSuggestAccountingItemsSelectorShow = false;

            this.suggestAccountItems = [];
        },
        fetchCash() {
            this.$api({
                url: '/Tool/GetCashBalance',
                method: 'GET',
            }).then((resp) => {
                this.currCash = resp.data.balance;
            });
        },
        handleCancel() {
            this.$emit('canceled');
        },
        handleTaxRatioChange() {
            this.updateTaxAmt();
        },
        handleGen2RatioChange() {
            this.updateGen2Amt();
        },
        handlePayWayChange() {
            if (this.form.paY_WAY === 1) this.form.paY_BNK_SNO = null;
        },
        updateTaxAmt() {
            if (this.taxCheck) {
                const PAY_TWD = Math.round(this.payment.amt * this.form.paY_CNYRAT);
                this.form.taX_AMT = Math.floor(PAY_TWD * (this.tax_ratio / 100));
            } else {
                this.form.taX_AMT = 0;
                this.form.taX_PAY_DAT = null;
                this.form.taX_BNK_SNO = null;
            }
        },
        updateGen2Amt() {
            if (this.gen2Check) {
                const PAY_TWD = Math.round(this.payment.amt * this.form.paY_CNYRAT);
                this.form.geN2_AMT = Math.round((PAY_TWD * this.gen2_ratio) / 100);
            } else {
                this.form.geN2_AMT = 0;
                this.form.geN2_PAY_DAT = null;
                this.form.geN2_BNK_SNO = null;
            }
        },
        handleFutureAlertDialogSubmit() {
            this.futureAlertDialog.visible = false;
            this.submit();
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    console.log('Payment Check', JSON.parse(JSON.stringify(this.form)));

                    // 檢查代扣所得稅日期不早於付款日期
                    if (this.payment.paY_TO === 3) {
                        if (this.isTaxPayDateInvalid || this.isGen2PayDateInvalid) {
                            this.$message({
                                showClose: true,
                                message: '代扣所得稅、代扣二代健保繳款日應於實際付款日之後',
                                type: 'error',
                            });
                            return;
                        }
                        if (this.form.serviceType === null) {
                            this.$message({
                                showClose: true,
                                message: '請填寫所得類別',
                                type: 'error',
                            });
                            return;
                        }

                        if ((this.form.serviceType === 1 || this.form.serviceType === 2) && this.form.serviceSubType === null) {
                            this.$message({
                                showClose: true,
                                message: '請填寫業別代號',
                                type: 'error',
                            });
                            return;
                        }

                        if (this.form.serviceType === 0 && this.form.otherServiceType === null) {
                            this.$message({
                                showClose: true,
                                message: '請填寫業別代號',
                                type: 'error',
                            });
                            return;
                        }
                    }

                    const today = new Date().getTime();
                    if (this.form.paY_DAT > today) {
                        this.futureAlertDialog.visible = true;
                        return;
                    }

                    this.$confirm('確定送出付款？', {
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                    }).then(() => {
                        this.submit();
                    });
                }
            });
        },
        submit() {
            this.isSubmitting = true;

            if (this.form.paY_WAY === 1) this.form.paY_BNK_SNO = null;

            if (this.form.serviceType === 1 || this.form.serviceType === 2) this.form.otherServiceType = null;
            else if (this.form.serviceType === 0) this.form.serviceSubType = null;
            else {
                this.form.serviceSubType = null;
                this.form.otherServiceType = null;
            }

            this.$api({
                url: '/PaymentManagenmentPage/AuditPayment',
                method: 'post',
                data: {
                    ...this.form,
                    taX_AMT: Math.round((this.form.taX_AMT / this.form.paY_CNYRAT) * 100) / 100,
                    taX_BNK_SNO: this.form.taX_BNK_SNO === -1 ? null : this.form.taX_BNK_SNO,
                    taX_PAY_WAY: this.form.taX_BNK_SNO === -1 ? 1 : 2,
                    geN2_AMT: Math.round((this.form.geN2_AMT / this.form.paY_CNYRAT) * 100) / 100,
                    geN2_BNK_SNO: this.form.geN2_BNK_SNO === -1 ? null : this.form.geN2_BNK_SNO,
                    geN2_PAY_WAY: this.form.geN2_BNK_SNO === -1 ? 1 : 2,
                },
            })
                .then(() => {
                    this.$emit('submitted');
                    this.$message({
                        showClose: true,
                        message: '付款通過！',
                        type: 'success',
                    });
                })
                .catch((e) => {
                    console.log(e);
                    if (e.response.data === '重複操作，審核流程已更新') {
                        this.$emit('submitted');
                    }
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        handleSave() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    console.log('Payment Save', JSON.parse(JSON.stringify(this.form)));

                    this.$api({
                        url: '/PaymentManagenmentPage/StashAuditPayment',
                        method: 'post',
                        data: {
                            ...this.form,
                            taX_AMT: Math.round((this.form.taX_AMT / this.form.paY_CNYRAT) * 100) / 100,
                            geN2_AMT: Math.round((this.form.geN2_AMT / this.form.paY_CNYRAT) * 100) / 100,
                        },
                    })
                        .then(() => {
                            this.$emit('submitted');
                            this.$message({
                                showClose: true,
                                message: '付款明細已暫存。',
                                type: 'success',
                            });
                        })
                        .finally(() => {
                            this.isSubmitting = false;
                        });

                    this.$emit('save');
                }
            });
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        applySysCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) {
                this.form.paY_CNYRAT = cnyOption.rat;
                this.onCnyRatChange();
            } else {
                alert(`找不到該幣別資料：${cny}`);
            }
        },
        getServiceTypeTxt(serviceTypeNum) {
            const s = serviceTypeList.find((x) => x.value === serviceTypeNum);
            if (s) return s.label;
            return '（未設定勞務所得類別）';
        },

        onAhRichAlertDialogCancel() {
            this.futureAlertDialog.visible = false;
        },
        onAhRichAlertDialogClose() {
            this.futureAlertDialog.visible = false;
        },

        onVariableStateItemChange(val) {
            this.isAhSuggestAccountingItemsSelectorShow = true;
            this.$nextTick(() => {
                this.$refs.ahSuggestAccountingItemsSelector.setSuggestAccountItems(val);
            });
        },
        onAhSuggestAccountingItemsSelectorLoaded() {
            this.isAhSuggestAccountingItemsSelectorShow = this.isPayed('G01') || this.$store.getters['account/isSAAdmin'];
        },
        onChangeServiceType() {
            this.form.serviceSubType = null;
            this.form.otherServiceType = null;
        },
    },
};
</script>
<style lang="scss">
.payment-detail-check {
    .tax-area-block {
        // border: 1px solid #eee;
        background-color: #f1f1f1;
        padding: 15px 20px;
        border-radius: 10px;

        .section {
            opacity: 0.4;
            transition: 0.2s;

            &.actived {
                opacity: 1;
            }
        }
    }

    .service-type-note {
        line-height: 150%;
        font-size: 10pt;
        color: #9e5f00;
        background-color: #fdf6ec;
        padding: 5px 15px;
        border-radius: 6px;
        margin: 10px 0;

        .title {
            margin: 10px 20px 0 20px;
            font-weight: bold;
        }

        li {
            margin-bottom: 10px;
        }
    }

    .pay-way-radio-group {
        .el-radio-button.is-active.is-disabled {
            .el-radio-button__inner {
                color: #fff;
                background-color: #463cb2;
            }
        }
    }

    .realpay-total {
        display: flex;
        margin-top: 20px;
        align-items: center;
        gap: 20px;
        justify-content: end;

        .money-input input {
            font-weight: bold;
        }
        .twd {
            text-align: right;
            font-size: 9.5pt;
            color: #999;
            margin: 5px 0 10px 0;
        }
    }
}
</style>
